/**
 * Social - Mail - Share
 */
import React from 'react'

export type MailShareProps = {
  body: string
  subject: string
}

// eslint-disable-next-line import/prefer-default-export
export const MailShare = ({ body, subject }: MailShareProps) => (
  <a href={`mailto:?subject=${subject}&body=Check out this site ${body}`}>
    <i className="far fa-envelope" />
  </a>
)
